var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.132 20.924 1 21.868 1.472 23l1.51.85-.85.47v1.604l1.415.472.566 1.32c.315.158 1.208.473 2.264.473 1.057-.001.755.565.472.848l1.414-.85 1.415.85 1.509-1.32h1.791v-1.322l.945-.472.754-.848-.472-1.227 1.32-1.982h4.246V23l.943 1.32v.756l.943.471v1.227l.755.283v1.132h1.981l.66.848.85-.85.754.85.944-.85h1.038l.754-1.792h.566v-1.32L31 24.32 29.962 23 31 21.868l-1.038-.944-.566-1.132-.754-1.132v-1.603l1.32-.566-.566-1.509-2.736-2.169-3.113-1.036-2.83-.85V9.227l1.698-1.32-1.132-.755-1.51.756v2.547h-1.132l-.847-3.302V6.114l.849-.849L15.528 3H6.85v2.264h.848l-1.32 6.51c-.66.314-2.265 1.15-3.397 1.98-1.13.83-1.791 2.17-1.98 2.737h1.132v2.17L1 19.792l1.132 1.132zm7.547-9.056H7.51l1.132-5.85h2.924l-1.887 5.85zm5.848.755 2.359 5.754-.755 1.038c-.189-.692-.943-2.49-2.453-4.15-1.51-1.661-3.02-2.454-3.586-2.642l1.604-6.604 3.868 1.13.566 3.208-1.604 2.265zm-4.34 9.056a2.83 2.83 0 1 1-5.66 0 2.83 2.83 0 0 1 5.66 0zm16.982 2.122a2.123 2.123 0 1 1-4.245 0 2.123 2.123 0 0 1 4.245 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/FARM.8cc6016b8f860bac4e502af9c1680543.svg";
export { ForwardRef as ReactComponent };